import { render } from "./ApplyPartnerPage.vue?vue&type=template&id=0f0c826a&scoped=true"
import script from "./ApplyPartnerPage.vue?vue&type=script&lang=js"
export * from "./ApplyPartnerPage.vue?vue&type=script&lang=js"

import "./ApplyPartnerPage.vue?vue&type=style&index=0&id=0f0c826a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0c826a"]])

export default __exports__